import React from 'react'
import { withStyles } from '@material-ui/core/styles'

const styles = (theme) => ({
	toolbar: {
		display: 'flex',
		flexWrap: 'wrap',
		backgroundColor: theme.palette.grey[300],
		minHeight: theme.spacing.unit * 6,
		paddingLeft: theme.spacing.unit * 3
	}
})

const Toolbar = ({ children, classes }) => (
	<div className={classes.toolbar}>
		{children}
	</div>
)

export default withStyles(styles)(Toolbar)



// WEBPACK FOOTER //
// ./src/components/Page/Toolbar.js